import React, { FC } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "./routes";

export const APPRouter: FC = () => (
  <Router>
    <Routes />
  </Router>
);
